"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toggleOverlay = exports.openMenuFirst = exports.toggleMenu = exports.ModelsMenuStateActionType = void 0;
var ModelsMenuStateActionType;
(function (ModelsMenuStateActionType) {
    ModelsMenuStateActionType["ToggleMenu"] = "models/TOGGLE_MENU";
    ModelsMenuStateActionType["OpenMenuFirst"] = "models/OPEN_MENU_FIRST";
    ModelsMenuStateActionType["OverlayToggle"] = "overlay/TOGGLE_MENU";
})(ModelsMenuStateActionType || (exports.ModelsMenuStateActionType = ModelsMenuStateActionType = {}));
const toggleMenu = (state) => ({
    type: ModelsMenuStateActionType.ToggleMenu,
    payload: state,
});
exports.toggleMenu = toggleMenu;
const openMenuFirst = () => ({
    type: ModelsMenuStateActionType.OpenMenuFirst,
    payload: true,
});
exports.openMenuFirst = openMenuFirst;
const toggleOverlay = (state) => ({
    type: ModelsMenuStateActionType.OverlayToggle,
    payload: state,
});
exports.toggleOverlay = toggleOverlay;
